import { useQuery, useMutation } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { toast } from "react-hot-toast";
import { API } from "../../../constants/api";
import { errorMessage } from "../../../utils/errorMessage";
import useAuthAxios from "../../../utils/baseAxios";
import ClipLoader from "react-spinners/ClipLoader";
import { useUser } from "../../../context/user-context";
import Select from "react-select";

const AddBanks = ({ setOpenAddBank }: any) => {
  const { refetch } = useUser();
  const [bankCode, setBankCode] = useState<string>("");
  const [bankNumber, setBankNumber] = useState<string>("");
  const [disabled, setDisabled] = useState<boolean>(false);
  const [bankName, setBankName] = useState<string>("");
  const [userBankName, setUserBankName] = useState<string>("");
  const { theme } = useUser();
  const [isChecked, setIsChecked] = useState(false);
  const axiosInstance = useAuthAxios();

  const getAllBanks = async () => {
    const response = await axiosInstance.get(API.getBanks);
    return response.data;
  };

  const { data: allBanks, error: error1 } = useQuery({
    queryKey: ["all-banks"],
    queryFn: getAllBanks,
    retry: 1,
  });
  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1]);
  const getbankName = async () => {
    const response = await axiosInstance.get(
      API.verifyAccountNumber(bankNumber, bankCode)
    );
    return response.data;
  };
  const {
    data: userName,
    error: error2,
    isLoading: loading,
  } = useQuery({
    queryKey: ["get-user-name"],
    queryFn: getbankName,
    retry: 1,
    enabled: bankNumber.length === 10 && !!bankCode,
  });
  //   console.log(userName);
  useEffect(() => {
    if (userName?.data.accountName && bankNumber.length === 10 && bankCode) {
      setUserBankName(userName?.data.accountName);
    }
  }, [bankCode, bankNumber.length, userName?.data.accountName]);
  useEffect(() => {
    if (error2) {
      const newError = error2 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error2]);

  const addBank = async ({ bankCode, accountNumber, isDefault }: any) => {
    const response = await axiosInstance.put(API.saveAccountDetails, {
      accountNumber,
      bankCode,
      isDefault,
    });
    return response.data;
  };

  const completeAddBank = useMutation({
    mutationFn: addBank,
    onSuccess: (r) => {
      toast.success(r.message);
      setTimeout(() => {
        refetch();
        setOpenAddBank(false);
      }, 1500);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });

  useEffect(() => {
    if (!bankName || bankNumber.length !== 10 || !userName) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [bankName, bankNumber.length, userName]);

  const customSelectStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: "transparent",
      borderColor: state.isFocused
        ? "#0B75C2"
        : theme === "dark"
        ? "#4B5563"
        : "#d1d5db",
      boxShadow: state.isFocused ? "0 0 0 1.5px #0B75C2" : "none",
      minHeight: "48px",
      borderRadius: "0.75rem",
      fontSize: "15px",
      color: theme === "dark" ? "#D1D5DB" : "#374151",
      outline: "none",
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? theme === "dark"
          ? "#192025"
          : "#E8F3FC"
        : state.isFocused
        ? theme === "dark"
          ? "#232B36"
          : "#F3F4F6"
        : theme === "dark"
        ? "#1F2B36"
        : "#fff",
      color: theme === "dark" ? "#D1D5DB" : "#1F2937",
      fontSize: "15px",
      padding: "10px 16px",
      cursor: "pointer",
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: theme === "dark" ? "#D1D5DB" : "#374151",
      fontWeight: 500,
    }),
    menu: (provided: any) => ({
      ...provided,
      borderRadius: "0.75rem",
      boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
      zIndex: 20,
      backgroundColor: theme === "dark" ? "#1F2B36" : "#fff",
    }),
    input: (provided: any) => ({
      ...provided,
      color: theme === "dark" ? "#D1D5DB" : "#374151",
      fontSize: "15px",
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: theme === "dark" ? "#6B7280" : "#6B7280",
      fontSize: "15px",
    }),
  };

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenAddBank(false);
              setBankNumber("");
              setBankCode("");
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Add Bank
          </h4>
        </div>
        <div className="mt-8 w-full">
          <div className={`w-full `}>
            <label className="text-gray-700  dark:text-gray-300">
              Account number
            </label>
            <input
              type="number"
              value={bankNumber}
              onChange={(e) => setBankNumber(e.target.value)}
              placeholder="Enter your account number"
              className="w-full dark:bg-[#1F2B36] dark:text-gray-300 text-gray-700 dark:border-[#095B97] h-[60px] mt-2 mb-6 lgss:mt-4 outline-none text-[15px] border border-gray-400 bg-[#F7F8F9] px-4 spin-button-none rounded-xl "
            />
            <label className="text-gray-700   dark:text-gray-300">
              Bank name
            </label>
            <div className="w-full mt-2 lgss:mt-4">
              <Select
                options={
                  allBanks?.data.map((bank: any) => ({
                    value: bank.bankCode,
                    label: bank.bankName,
                  })) || []
                }
                onChange={(selected: any) => {
                  setBankCode(selected.value);
                  setBankName(selected.label);
                }}
                placeholder="Select bank"
                isSearchable
                classNamePrefix="react-select"
                styles={customSelectStyles}
              />
            </div>
            <h4 className="text-[14px] mt-2 font-bold text-[#d39c54]">
              {loading ? (
                <ClipLoader color="#FFFFFF" size={30} />
              ) : (
                `${userBankName}`
              )}
            </h4>
            {userBankName && (
              <div className="mt-4 flex justify-start gap-3 items-center">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                  className="h-[18px] w-[18px]"
                />
                <h4 className="text-[13px] text-gray-700 dark:text-gray-300 font-sora font-semibold">
                  Make default bank
                </h4>
              </div>
            )}

            <button
              onClick={() => {
                const requestData = {
                  accountNumber: bankNumber,
                  bankCode: bankCode,
                  is_default: false,
                };
                if (isChecked) {
                  requestData.is_default = true;
                }
                completeAddBank.mutate(requestData);
              }}
              disabled={disabled}
              className={
                disabled
                  ? "w-full h-[52px] flex justify-center items-center font-manrope mx-auto text-gray-200  rounded-xl bg-gray-400 dark:bg-[#8f9294]  mt-8"
                  : "w-full h-[52px] flex justify-center items-center font-manrope mx-auto  font-medium rounded-xl text-white bg-secondary_button mt-8"
              }
            >
              {completeAddBank.isPending ? (
                <ClipLoader color="#FFFFFF" size={30} />
              ) : (
                "Confirm"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBanks;
